module.exports = __webpack_public_path__ + "public/images/computer.0b1d42be7be2b61b3487f6b4da7c7621.svg";